import React from 'react'


const Hyperlinkpolicy = () => {
  return (
 <div>
    <div class="heading"><h2>Hyperlink Policy</h2></div>
    <div class="content-container">
      

      <div>

        <div class="policycontent-container">

          <div className='policycontent'>
            <p>We do not object to you linking directly to the information that is hosted on our site and no prior permission is required for the same. However, we would like you to inform us about any links provided to our site so that you can be informed of any changes or updations therein. Also, we do not permit our pages to be loaded into frames on your site. Our Department's pages must load into a newly opened browser window of the user.</p>
          </div>
        </div>
      </div>
    </div>
    </div>
   
  )
}

export default Hyperlinkpolicy
